<template>
    <div class="flexible-space-wrapper">
        <component
            v-for="component in getActiveComponents(
                'CategoryPage',
                'B',
                dynamicComponents
            )"
            :key="component.name"
            :is="component.name"
            v-bind="component.props"
        />
    </div>
</template>

<script>
import { flexibleSpaceMixin, partnersMixin } from '@/mixins';
import { FLEXIBLE_COMPONENTS } from '@/constants';
const {
    TESTIMONIALS,
    ARTICLE_CARDS,
    PARTNER_PODIUM,
    SIDEBAR_BILLBOARD,
    BLACK_FRIDAY_BADGE,
} = FLEXIBLE_COMPONENTS;

export default {
    name: 'FlexibleSpaceB',
    components: {
        Testimonials: () =>
            import(
                '@/design-system/2_molecules/TestimonialCard/TestimonialCard.vue'
            ),
        ArticleCards: () =>
            import('@organisms/ArticleCards/ArticleCardsContainer'),
        [PARTNER_PODIUM]: () =>
            import('@molecules/PartnerPodium/PartnerPodium'),
        SidebarBillboard: () =>
            import('@molecules/SidebarBillboard/SidebarBillboard'),
        [BLACK_FRIDAY_BADGE]: () =>
            import('@molecules/BlackFridayBadge/BlackFridayBadge'),
    },
    mixins: [partnersMixin, flexibleSpaceMixin],
    computed: {
        testimonialArray() {
            let testimonialArray = [];
            Object.keys(this.$globalConstants['host']).forEach((item) => {
                return item.includes('testimonial_')
                    ? testimonialArray.push(this.$globalConstants['host'][item])
                    : null;
            });

            return testimonialArray;
        },
        dynamicComponents() {
            return {
                [TESTIMONIALS]: {
                    shouldShow: true,
                    props: {
                        testimonials: this.testimonialArray,
                        quotePartners: this.testimonialPartners,
                        ...this.$globalConstants.components[TESTIMONIALS],
                    },
                },
                [ARTICLE_CARDS]: {
                    shouldShow: true,
                    props: {},
                },
                [PARTNER_PODIUM]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                    props: {
                        ...this.$globalConstants.components[PARTNER_PODIUM],
                        partners: this.podiumPartners,
                    },
                },
                [SIDEBAR_BILLBOARD]: {
                    shouldShow:
                        this.$globalConstants.host[
                            'sidebar_billboard_desktop'
                        ] &&
                        !this.isMobileDevice() &&
                        this.categoryState.isLoaded &&
                        this.categoryState['sidebar_billboard_partner'],
                    props: {
                        partner:
                            this.categoryState['sidebar_billboard_partner'],
                    },
                },
                [BLACK_FRIDAY_BADGE]: {
                    shouldShow:
                        Boolean(
                            this.$globalConstants.host['black_friday_badge']
                        ) ||
                        Boolean(this.$globalConstants.host['christmas_badge']),
                    props: {
                        ...this.$globalConstants.components[BLACK_FRIDAY_BADGE],
                        christmasTheme: Boolean(
                            this.$globalConstants.host['christmas_badge']
                        ),
                    },
                },
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.flexible-space-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
}
</style>
